import axios from 'axios'

const objetos = {}

objetos.find = (params) => {
	let filters = {
		ordenarPor: params && params.ordenarPor ? params.ordenarPor : 'Nome',
		ordem: params && params.ordem ? params.ordem : 'asc',
		skip: params && params.skip ? params.skip : 0
	}

	if (params && params.texto) {
		filters = {
			...filters,
			texto: params.texto
		}
	}

	if (params && params.tipos && params.tipos.length > 0) {
		filters = {
			...filters,
			tipos: params.tipos.toString()
		}
	}

	if (params && params.curadorias && params.curadorias.length > 0) {
		filters = {
			...filters,
			curadorias: params.curadorias.toString()
		}
	}

	if (params && params.subCuradorias && params.curadorias.length > 0) {
		filters = {
			...filters,
			subcuradoria: params.subcuradoria.toString()
		}
	}

	if (params && params.eixos && params.eixos.length > 0) {
		filters = {
			...filters,
			eixos: params.eixos.toString()
		}
	}

	if (params && params.cursoId && params.cursoId.length > 0) {
		filters = {
			...filters,
			cursoId: params.cursoId.toString()
		}
	}

	if (params && params.disciplinaId && params.disciplinaId.length > 0) {
		filters = {
			...filters,
			disciplinaId: params.disciplinaId.toString()
		}
	}

	if (params && params.data && params.data.length > 0) {
		filters = {
			...filters,
			data: params.data.toString()
		}
	}

	return axios.get('/objetos', { params: filters })
}

objetos.findById = id => axios.get(`/objetos/${id}`)

objetos.relatedObjects = id => axios.get(`/objetos/relacionados?objetoId=${id}`)

objetos.updateColecoes = (id, data) => axios.put(`/objetos/${id}/colecoes`, data)

objetos.countStocks = (data) => axios.post('/objetos/contabilizar_acoes', data)

export { objetos }
